import DopeIcon from './DopeIcon';

export default DopeIcon;
